import type { TrackingEventProperties } from "instrumentation/tracking/useWoopraApi"

export const PAGE_VIEW_EVENT = "page_view"

const NOT_FOUND_PAGE = "/not-found"

const staticPageTitlesByPath: Record<string, string> = {
  "/": "Home",
  "/admin/maintenance-notification": "Maintenance Notification Admin",
  "/admin/pool-portal": "Pool Portal Admin",
  "/admin/reports": "Admin Reports",
  "/admin/seamargin": "Sea Margin Admin",
  "/admin/sidebar": "Sidebar Admin",
  "/chartering-insights": "Chartering Insights",
  "/freight-optimizer": "Freight Optimizer",
  "/not-found": "Not Found",
  "/pool-portal/agreements": "Pool Portal / Agreements",
  "/pool-portal/hire-statements": "Pool Portal / Hire Statements",
  "/pool-portal/newsletters": "Pool Portal / Newsletters",
  "/port-holidays-upload": "Port Holidays Upload",
  "/port-predictor": "Port Predictor",
  "/portpredictor-backtest": "Port Predictor Backtest",
  "/prevetting": "Prevetting",
  "/reports-overview": "Reports Overview",
  "/user-profile": "User Profile",
  "/version": "Version",
  "/vesseltracking": "Vessel Tracking",
}

export type PageViewContext = {
  routePath: string
  routeName?: string
  permissionForPage?: string
}

export function normalizePagePath(path: string) {
  if (path === "*") {
    return NOT_FOUND_PAGE
  }

  if (path === "/") {
    return path
  }

  return path.startsWith("/") ? path : `/${path}`
}

export function getPageTitle({
  routeName,
  routePath,
}: Pick<PageViewContext, "routeName" | "routePath">) {
  if (routeName) {
    return routeName
  }

  const pagePath = normalizePagePath(routePath)
  const staticTitle = staticPageTitlesByPath[pagePath]
  if (staticTitle) {
    return staticTitle
  }

  return pagePath
    .replace(/^\//, "")
    .split("/")
    .map((part) =>
      part
        .split("-")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    )
    .join(" / ")
}

export function buildPageViewProperties({
  path,
  routePath,
  routeName,
  permissionForPage,
  referrerPath,
}: PageViewContext & {
  path: string
  referrerPath: string
}): TrackingEventProperties {
  const properties: TrackingEventProperties = {
    path,
    routePath,
    pageTitle: getPageTitle({ routeName, routePath }),
    component: "router",
  }

  if (permissionForPage) {
    properties.permission = permissionForPage
  }

  if (referrerPath) {
    properties.referrerPath = referrerPath
  }

  return properties
}
